import React, { useState } from "react";
import { Stack, TextField } from "@mui/material";
import { Typography, Button, Dialog, DialogContent } from "@mui/material";
import { useDispatch } from "react-redux";
import { addCat, removeCat } from "./categorySlice";
import { toast } from "react-toastify";
import Repo from "../../Repository/Repo";

function AddCategory({ onClose }) {
  const companyCode = localStorage.getItem("companyCode");
  const dispatch = useDispatch();
  const [state, setState] = useState({
    loading: false,
    title: "",
  });

  const handleChange = (e) => {
    let { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      dispatch(addCat(state.title));
      onClose();
      let { data } = await Repo.category({
        request: {
          method: "saveDaybookCategory",
          data: {
            company_code: companyCode,
            category: state.title,
          },
        },
      });

      if (data.response.status.statusCode == 200) {
        toast.configure();
        toast.success("Added Successfully");
      } else {
        toast.configure();
        toast.error("Category Not Added");
        dispatch(removeCat({ index: 0 }));
      }
    } catch (err) {
      console.log(err);
      toast.configure();
      toast.error("Error");
    }
  };
  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing={4} direction="column">
          <Typography
            variant="h5"
            sx={{ textAlign: "center", color: "#4EAF51" }}
          >
            Add New Category
          </Typography>
          <TextField
            size="small"
            autoFocus
            fullWidth
            name="title"
            label="Add Category"
            value={state.title}
            onChange={handleChange}
            variant="outlined"
          />
          <Stack direction="row" justifyContent="space-between">
            <Button
              variant="contained"
              sx={{ background: "rgb(138, 138, 138) !important" }}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSubmit}>
              Add
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default AddCategory;
